export default __webpack_public_path__ + "static/transaction-page-review-7e82e3540ed8b6c2c4a3ebd4506146a1.png";